var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tour"},[_c('Head',{attrs:{"type":"back","name":"tour","title":_vm.introData.mingle_title}}),_c('div',{staticClass:"tour_sub_wrap"},[_c('TourSwiper',{attrs:{"introData":_vm.introData,"introImage":_vm.introImage}}),_c('TourPlace'),_c('TourService'),_c('PopupSns')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }